<template>
	<div class="form-inputs">
		<FormLabelTooltip
			:name="`input-${name}`"
			:label="label"
			:tooltip="tooltip"
		/>
		<masked-input
			class="b360-form-input"
			:class="{ error: error }"
			:id="`input-${name}`"
			:type="type"
			:placeholder="placeholder"
			:pattern="pattern"
			:mask="getMask()"
			:required="required"
			:value="value"
			:disabled="disabled"
			@change="handleInput"
			@input="
				(event) => {
					$emit('input', event);
				}
			"
			@blur="$emit('blur')"
		>
		</masked-input>
	</div>
</template>

<script>
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';
import MaskedInput from 'vue-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default {
	name: 'FormMaskedInputs',
	components: {
		FormLabelTooltip,
		MaskedInput,
	},
	props: [
		'name',
		'label',
		'type',
		'placeholder',
		'pattern',
		'mask',
		'required',
		'formField',
		'value',
		'tooltip',
		'disabled',
		'error',
	],
	data() {
		return {
			maskOneDigit: {
				prefix: '',
				allowDecimal: false,
				integerLimit: 1,
			},
			maskFourDigits: {
				prefix: '',
				includeThousandsSeparator: false,
				allowDecimal: false,
				integerLimit: 4,
			},
			maskCreditScore: {
				prefix: '',
				allowDecimal: false,
				integerLimit: 3,
			},
			maskZipCode: {
				prefix: '',
				includeThousandsSeparator: false,
				allowDecimal: false,
				integerLimit: 5,
				allowLeadingZeroes: true,
			},
			maskDollar: {
				prefix: '$ ',
				includeThousandsSeparator: false,
				allowDecimal: false,
				integerLimit: 9,
			},
			maskCurrency: {
				prefix: '$ ',
				includeThousandsSeparator: true,
				allowDecimal: true,
				integerLimit: 9,
				decimalLimit: 2,
			},
			maskPercentage: {
				prefix: '',
				suffix: ' %',
				allowDecimal: true,
				integerLimit: 3,
			},
			maskYears: {
				prefix: '',
				suffix: ' Years',
				allowDecimal: false,
				integerLimit: 3,
			},
		};
	},
	methods: {
		handleInput(event) {
			this.$emit('change-event', event);
		},

		getMask() {
			const maskParams = this[this.mask];

			return createNumberMask(maskParams);
		},
	},
};
</script>

<style scoped lang="scss">
.b360-form-label {
	display: flex;
	justify-content: space-between;
}
.error {
	border: 1px solid $error;
}
</style>
